import {Form as RouterForm} from 'react-router-dom';
import {Tabs} from '../../components/tabs/tabs';
import {useAppSelector} from '../../store/store';
import {Details} from './tabs/details';
import {CustomerFieldKeys, getValue} from '../../support/get_data.ts';
import {useIsNavigatingOrPending} from '../../support/use_is_navigating_or_pending';
import {__} from '../../support/lang/translations';
import {Address} from './tabs/address.tsx';
import {Preferences} from './tabs/preferences.tsx';
import {Button} from '../../components/button/button.tsx';
import {Avatar} from '../../components/avatar/avatar.tsx';
import {Page} from '../../components/page/page.tsx';
import {FormFooter} from '../../components/form_footer/form_footer.tsx';
import {Main} from '../../components/main/main.tsx';
import mainStyles from '../../components/main/main.module.scss';
import {ButtonPosition} from '../../enums/button_position.ts';

export function Profile() {
    const isLoading = useIsNavigatingOrPending((state) => state.customerInfo.status);
    const meData = useAppSelector((state) => state.customerInfo.me?.customer);

    const nameData = getValue(meData, CustomerFieldKeys.NAME);
    const prepositionData = getValue(meData, CustomerFieldKeys.PREPOSITION);
    const surNameData = getValue(meData, CustomerFieldKeys.SURNAME);
    const fullName = [nameData?.value, prepositionData?.value, surNameData?.value]
        .filter((part) => part && part?.length > 0)
        .join(' ');

    return (
        <Main className={mainStyles.bg_white}>
            <Page isLoading={isLoading}>
                <Avatar name={fullName} src={meData?.profilePicture?.signed_url} editable={true} />
                <RouterForm method="post">
                    <Tabs
                        disabled={isLoading}
                        name="profile"
                        tabs={[
                            {
                                id: 'data',
                                link: <span>{__('profile.tabs.data')}</span>,
                                child: <Details />,
                            },
                            {
                                id: 'address',
                                link: <span>{__('profile.tabs.address')}</span>,
                                child: <Address />,
                            },
                            {
                                id: 'preferences',
                                link: <span>{__('profile.tabs.preferences')}</span>,
                                child: <Preferences />,
                            },
                        ]}
                    />
                    <FormFooter gray={true}>
                        <Button disabled={isLoading} loading={isLoading} position={ButtonPosition.Right}>
                            <i className={isLoading ? 'fa-light fa-refresh' : 'fa-light fa-check'} />
                            <span>{__('profile.buttons.save')}</span>
                        </Button>
                    </FormFooter>
                </RouterForm>
            </Page>
        </Main>
    );
}
